import React, { useContext, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Modal from "../../components/advance/Modal";
import OTPInput from "../../components/base/OtpInput.js";
import Button from "../../components/core/EPL_Button_Think";
import useMediaQuery from "../../hooks/useMediaQuery";
import { encrypt } from "../../utils/crypto";
import sendRequest from "../../utils/sendRequest";
import {
    GetCustomerDetailsContext,
    validateInputExistenece,
} from "../../App";
import {
    SEND_EMAIL_OTP,
    VERIFY_EMAIL_OTP,
} from "../../Config";
import timer from "../../assets/svg/EPL_think_svg/timer.svg";
import { updateLead } from "../../shared/services/crm";
import { getRouteFromLoanStageService } from "../../shared/services/getRouteFromLoanStageService";
import { isValidOTP } from "../../shared/validations/OTP";
import {
    IncorrectOtpModal,
    MaxOtpRetryModal,
    OtpExpiredModal,
    ResendOtpEmailModal,
    CheckInternetModal,
} from "../other-pages/Modals/AllModal";
import { AfterLoginLayoutWrapper } from "../_styles/EPL_AfterLoginLayoutWrapper_think.js";
import { encryptedData } from "../../utils/index.js";

const DetailsVerify = () => {
    const isMobile = useMediaQuery("screen and (max-width: 768px)");
    const navigate = useNavigate();
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const [customerDetails, setCustomerDetails] = useContext(
        GetCustomerDetailsContext
    );
    const [showShimmer, setShowShimmer] = useState(true);
    const [isOtpValid, setIsOtpValid] = useState(false);
    const [enableResendOtp, SetEnableResendOtp] = useState(false);
    const [seconds, setSeconds] = useState();
    const [minutes, setMinutes] = useState();
    const [showOtpExpiredModal, setShowOtpExpiredModal] = useState(false);
    const [internetCheck, setInternetCheck] = useState(false);
    const [resendOtp, setResendOtp] = useState(false);
    const [otp, setOtp] = useState("");
    const [showMaxRetryModal, setShowMaxRetryModal] = useState(false);
    const [isOtpwrong, SetIsOtpWrong] = useState(false);
    const [otpDigits, setOtpDigits] = useState(Array(6).fill(""));
    const [showOtpModal, setShowOtpModal] = useState(false);
    const [skipBtn, setSkipBtn] = useState(false);

    useEffect(async () => {
        if (
            validateInputExistenece(customerDetails) &&
            validateInputExistenece(customerDetails["stage"])
        ) {
            let route = getRouteFromLoanStageService({
                source: customerDetails.source,
                stage: customerDetails.stage,
            });
            navigate(route, {
                replace: true,
                state: {
                    customerDetails: customerDetails,
                },
            });
        }
    }, [customerDetails]);

    useEffect(() => {
        if (customerDetails?.stage === "EMAIL_OTP_VERIFICATION") {
            resendOTP()
            setShowOtpModal(true)
        }
    }, [])

    useEffect(() => {
        let otpString = otpDigits.join("");
        if (isValidOTP(otpString)) {
            setIsOtpValid(true);
            setOtp(otpString);
        } else {
            setIsOtpValid(false);
        }
    }, [otpDigits]);

    useEffect(() => {
        const interval = setInterval(() => {
            if (seconds > 0) {
                setSeconds(seconds - 1);
            }
            if (seconds === 0) {
                if (minutes === 0) {
                    clearInterval(interval);
                    SetEnableResendOtp(true);
                } else {
                    setSeconds(59);
                    setMinutes(minutes - 1);
                }
            }
        }, 1000);

        return () => {
            clearInterval(interval);
        };
    }, [seconds]);

    const resendOTP = async () => {
        let payload = {
            application_form_no: customerDetails?.application_form_number,
            email: customerDetails.Data?.org_email_id,
            mode: "EMPLOYMENT_CHECK",
        };
        try {
            const formData = new FormData();
            formData.append("data", encryptedData(payload));
            setShowShimmer(true);
            const response = await sendRequest(
                "/" + customerDetails.source + SEND_EMAIL_OTP,
                formData
            );
            // console.log("Response: ", response);
            if (response.response.Success) {
                setShowOtpModal(false);
                setShowShimmer(false);
                setResendOtp(true);
                SetEnableResendOtp(false);
                setMinutes(0);
                setSeconds(10);
                resetOTP();
            } else {
                setSkipBtn(response?.response?.Data?.otp_skip)
            }
            if (response.response.ErrorType == "OTP_MAX_RETRY") {
                setShowShimmer(false);
                setShowMaxRetryModal(true);
                setMinutes(15);
                setSeconds(1);
                SetEnableResendOtp(false);
            }
        } catch (error) {
            if (customerDetails.source === "upsell") {
                updateLead(
                    customerDetails.source,
                    64,
                    customerDetails.application_form_number
                );
            } else {
                updateLead(
                    customerDetails.source,
                    64,
                    customerDetails.application_form_number
                );
            }
            console.error(`Unknown Error: Constants Not Retireved - ${error}`);
            if (error === "Unauthorised") {
                let route = getRouteFromLoanStageService({
                    source: customerDetails.source,
                    stage: "",
                });
                navigate(`${route}`, {
                    replace: true,
                });
            } else {
                let route = getRouteFromLoanStageService({
                    source: customerDetails.source,
                    stage: "error",
                });

                navigate(`${route}`, {
                    replace: true,
                });
            }
        }
    };

    const VerifyOTPOnEmail = async (skipOtp = false) => {
        try {
            let payload = {
                application_form_no: customerDetails?.application_form_number,
                otp: otp,
                email: customerDetails.Data?.org_email_id,
                mode: "EMPLOYMENT_CHECK",
            };
            // Only add `otp_skip` to the payload if `skipOtp` is true
            if (skipOtp) {
                payload.otp_skip = true;
            }
            setShowOtpModal(false);
            const formData = new FormData();
            formData.append("data", encryptedData(payload));
            const response = await sendRequest(
                "/" + customerDetails.source + VERIFY_EMAIL_OTP,
                formData
            );
            if (response.response.Success) {
                setShowShimmer(false);
                setCustomerDetails({
                    ...customerDetails,
                    stage: response.response.STAGE,
                });
            }
            if (response.response.ErrorType == "INVALID_OTP") {
                setShowShimmer(false);
                SetIsOtpWrong(true);
            }
            if (response.response.ErrorType == "OTP_EXPIRED") {
                setShowShimmer(false);
                setShowOtpExpiredModal(true);
            }
        } catch (error) {
            if (customerDetails.source === "upsell") {
                updateLead(
                    customerDetails.source,
                    64,
                    customerDetails.application_form_number
                );
            } else {
                updateLead(
                    customerDetails.source,
                    64,
                    customerDetails.application_form_number
                );
            }
            let route = getRouteFromLoanStageService({
                source: customerDetails.source,
                stage: "error",
            });
            navigate(`${route}`, {
                replace: true,
            });
        }
    };

    const resetOTP = async () => {
        const newOtpDigits = [...otpDigits];
        for (let i = 0; i < 6; i++) {
            newOtpDigits[i] = "";
        }
        setOtpDigits(newOtpDigits);
    };

    return (
        <AfterLoginLayoutWrapper>
            <Modal
                open={showOtpModal}
                showCloseButton={false}
                closeonClickOutside={false}
                onClose={() => { }}
                id="bd-email-otp-parent"
            >
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div
                            className="modal-body"
                            style={{
                                border: "1px solid #A7A7A7",
                                padding: "1rem",
                            }}
                        >
                            <div className="pupup-inner">
                                <div className="title text-center">
                                    <h2 className="fs-36 font-weight-medium text-black mb-2 lh-1">
                                        Verify Email
                                    </h2>
                                    <p className="fs-20 font-weight-medium text-black mb-4 pb-2 lh-1">
                                        by entering OTP
                                    </p>
                                </div>
                                <form>
                                    <div
                                        style={{
                                            marginLeft: "10px",
                                            marginRight: "10px",
                                            marginTop: "15px",
                                        }}
                                    >
                                        <div>
                                            <OTPInput
                                                length={6}
                                                otpDigits={otpDigits}
                                                setOtpDigits={setOtpDigits}
                                            />
                                        </div>
                                    </div>
                                    <div
                                        style={{
                                            display: "flex",
                                            justifyContent: "center",
                                            color: "#717171",
                                            fontSize: "12px",
                                            marginTop: "10px",
                                            marginBottom: "10px",
                                            alignItems: "center",
                                        }}
                                    >
                                        <div
                                            style={{
                                                display: "flex",
                                                flexDirection: "row",
                                                alignItems: "center",
                                                justifyContent: "center",
                                            }}
                                        >
                                            {enableResendOtp ? (
                                                <></>
                                            ) : (
                                                <>
                                                    <img
                                                        style={{
                                                            height: "15px",
                                                            width: "15px",
                                                            justifyContent: "center",
                                                            marginRight: "4px",
                                                        }}
                                                        src={timer}
                                                    />
                                                </>
                                            )}
                                            <text
                                                style={{
                                                    border: "None",
                                                    backgroundColor: "white",
                                                    color: enableResendOtp ? "#3C94FC" : "grey",
                                                    marginRight: "5px",
                                                    fontSize: "14px",
                                                    cursor: "pointer",
                                                }}
                                                onClick={() => {
                                                    resendOTP();
                                                }}
                                            >
                                                Re-send OTP
                                            </text>
                                        </div>
                                        {enableResendOtp ? (
                                            <></>
                                        ) : (
                                            <>
                                                <div>
                                                    in {minutes < 10 ? `0${minutes}` : minutes}:
                                                    {seconds < 10 ? `0${seconds}` : seconds}
                                                </div>
                                            </>
                                        )}
                                    </div>
                                    <div className="col-12 col-md-10 col-lg-8 col-xl-8 mx-auto">
                                        <div className="col-wrap text-center d-flex">
                                            <Button
                                                id="VerifyOTP"
                                                className="Btn VerifyOTP"
                                                disabled={!isOtpValid}
                                                mobile={isMobile}
                                                onClick={async () => {
                                                    await VerifyOTPOnEmail();
                                                }}
                                                text={"Verify"}
                                            />
                                            {
                                                skipBtn &&
                                                <Button
                                                    id="VerifyOTP"
                                                    className="Btn VerifyOTP"
                                                    mobile={isMobile}
                                                    onClick={async () => {
                                                        await VerifyOTPOnEmail(true);
                                                    }}
                                                    text={"Skip"}
                                                />
                                            }
                                        </div>
                                    </div>
                                    <p
                                        style={{
                                            textAlign: "center",
                                            paddingTop: "15px",
                                        }}
                                    >
                                        6 digit verification code sent to email ID will be
                                        valid for next 5 minutes.
                                    </p>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal>
            <CheckInternetModal
                isOpen={internetCheck}
                onClose={() => {
                    setInternetCheck(false);
                    setShowShimmer(false);
                }}
            />
            <OtpExpiredModal
                isOpen={showOtpExpiredModal}
                onClose={() => {
                    setShowOtpExpiredModal(false);
                    setShowOtpModal(true);
                    SetEnableResendOtp(false);
                    setSeconds(10);
                    resetOTP();
                }}
            />
            <ResendOtpEmailModal
                isOpen={resendOtp}
                onClose={() => {
                    setShowOtpModal(true);
                    SetEnableResendOtp(false);
                    setResendOtp(false);
                    setSeconds(10);
                    resetOTP();
                }}
            />
            <MaxOtpRetryModal
                isOpen={showMaxRetryModal}
                onClose={() => {
                    setShowMaxRetryModal(false);
                    SetEnableResendOtp(false);
                    setResendOtp(false);
                    setMinutes(15);
                    setSeconds(1);
                    resetOTP();
                }}
            />
            <IncorrectOtpModal
                isOpen={isOtpwrong}
                onClose={() => {
                    SetIsOtpWrong(false);
                    setShowOtpModal(true);
                    resetOTP();
                }}
            />
        </AfterLoginLayoutWrapper>
    );
};

export default DetailsVerify;